import * as React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'
import { findPet } from '../../helpers/commandHelper.ts'
import { gibiTheme } from '../../helpers/materialTheme.ts'
import { Toast } from '../common/Toast/Toast.tsx'
import { MenuDrawer } from './drawers/MenuDrawer.tsx'
import { FindDrawer } from './drawers/FindDrawer.tsx'
import { MainMenu } from './menus/MainMenu.tsx'
import { NavBar } from './bars/NavBar.tsx'
import { TapBar } from './bars/TapBar.tsx'
import { IPet } from '../../interfaces/types.ts'
import { FindPetMenu } from './menus/FindPetMenu.tsx'
import './Layout.css'
import controlStore from '../../store/controlStore.ts'
import { WebSocket } from '../../webSockets/WebSocket.tsx'

export const Layout: React.FC = () => {
    const selected = controlStore(s => s.currentPage)
    const menuOpen = controlStore(s => s.menuOpen)
    const findOpen = controlStore(s => s.findOpen)
    const navigate = useNavigate()
    const isMobile = controlStore(s => s.isOnMobileDevice)

    const menuAction = (page: string, state: any = {}) => {
        controlStore.getState().setMenuOpen(false)
        controlStore.getState().setFindOpen(false)

        navigate(page, {state})
    }

    const doFind = async (pet: IPet) => {
        await findPet(pet)
    }
    
    const layout = (
        <div className={'wrapper'}>
            {isMobile ? <aside>
                <TapBar selected={selected} setSelected={controlStore.getState().setCurrentPage} menuOpen={menuOpen}
                        setMenuOpen={controlStore.getState().setMenuOpen} findOpen={findOpen} setFindOpen={controlStore.getState().setFindOpen}/>
            </aside> : null}
            {!isMobile ? <NavBar selected={selected} setSelected={controlStore.getState().setCurrentPage} findOpen={findOpen} setFindOpen={controlStore.getState().setFindOpen}/>
            : null}
            <main>
                <div className={`${isMobile ? 'wrapper-inner' : 'desktop-wrapper-inner'}`}>
                    <Outlet/>
                    <MenuDrawer open={menuOpen} menu={<MainMenu menuAction={menuAction}/>}>
                        <FindDrawer open={findOpen} menu={<FindPetMenu menuAction={doFind}/>}>
                            <div/>
                        </FindDrawer>
                    </MenuDrawer>
                </div>
            </main>
            <WebSocket/>
        </div>
    )

    return (
        <ThemeProvider theme={gibiTheme}>
            {layout}
            <Toast/>
        </ThemeProvider>
    )
}
